<template>
	<el-dialog :title="$t('course_index.record')" :close-on-click-modal="false" :visible.sync="is_operation_records" :before-close="before_close" width="1200px">
		<el-table :data="list" border size="mini">
			<el-table-column prop="create_time" align="center" :label="$t('virtual.time')" data-nam="时间">
				<template slot-scope="scope"> {{getTime_us(scope.row.create_time,'mmddyyyy')}} {{getTime_us(scope.row.create_time,'hh:ii')}} </template>
			</el-table-column>
			<el-table-column prop="theme" align="center" :label="$t('virtual.subject')" data-name="主题">
				<template slot-scope="{row}"> {{lang=='cn'?row.theme_cn:row.theme}}</template>
			</el-table-column>
			<el-table-column prop="user_name" align="center" :label="$t('journal.user_name')" data-name="操作人"></el-table-column>
			<el-table-column prop="content_sys" align="center" :label="$t('parent_index.remarks')" data-name="操作备注">
				<template slot-scope="{row}">
					<div v-if="row.content_sys.field=='is_up'">
						<div v-if="row.content_sys.value=='0'">{{$t('course_index.up_0')}}</div>
						<div v-if="row.content_sys.value=='1'">{{$t('course_index.up_1')}}</div>
					</div>
					<div v-else-if="row.content_sys.field=='course_password'">{{$t('course_index.course_edit')}}</div>
				</template>
			</el-table-column>
		</el-table>
		<div class="page-pagination">
			<el-pagination align="right" small background :hide-on-single-page="false" @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="pages.page" :page-sizes="[10, 20, 30, 40, 50, 100]" :page-size="pages.perpage" layout="total, prev, pager, next, sizes, jumper" :total="pages.count" :pager-count="5"></el-pagination>
		</div>
	</el-dialog>
</template>
<script>
export default {
	computed: {
		editFormRules() {
			return {
				reply: [{
					required: true,
					message: this.$t('index.pleaseInput') + this.$t('virtual.reply'),
					trigger: 'change'
				}],
			}
		},
	},
	props:{
		table: {
			type: String,
			default:''
		},
		pk_id: {
			type: Number,
			default:0
		},
		is_operation_records: {
			type: Boolean,
			default:false,
		},
	},
	data() {
		return {
			pages: {
				page: 1,
				count: 0,
				perpage: 20,
			},
			list:[],
		}
	},
	watch: {
		is_operation_records(v){
			if (v) {
				this.init();
			}
		}
	},
	// 初始事件
	mounted () {
	},
	// 事件
	methods: {
		init(){
			var url = "logList";
			var datas = {
				table:this.table,
				pk_id: this.pk_id,
				page: this.pages.page,
				num: this.pages.perpage,
			};
			this.$post(url, datas).then((res) => {
				this.list = res.list;
				this.pages.count = res.sum;
			})
		},
		before_close(){
			this.$emit("callback");
		},
		// 分页每页显示几条
		handleSizeChange(val) {
			var pages = this.pages;
			pages['perpage'] = val;
			this.pages = pages;
			this.init();
		},
		// 切换分页
		handleCurrentChange(val) {
			var pages = this.pages;
			pages['page'] = val;
			this.pages = pages;
			this.init();
		}
	},
	// 过滤器
	filters: {

	}
}
</script>
<style scoped>
.page-pagination{
	padding: 20px 10px 0;
}
</style>



// WEBPACK FOOTER //
// src/views/teacher/components/operation_records.vue